import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contact',
  templateUrl: 'Academy.component.html',
  styleUrls: ['./Academy.component.css']
})
export class AcademyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
